export const apiVersion = 'v1';
export const timeout = 5000;
export const isProduction = true;

const localUrl = 'http://localhost:4000';
const prodUrl = 'https://do.codewithme.co.ke';
export const rootUrl = process.env.NODE_ENV === 'production' ? prodUrl : localUrl;

const localFrontendUrl = 'http://localhost:3000';
const prodFrontendUrl = process.env.REACT_APP_FRONTEND_BASE_URL || '';
export const frontendUrl = process.env.NODE_ENV === 'production' ? prodFrontendUrl : localFrontendUrl;